// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"2437fab8","125":"9d4562cf","202":"f90dd93a","416":"079b2a78","507":"dd0f254f","854":"34f39f48"}[chunkId] + ".chunk.js";
};